import styled from 'styled-components';
import { graySphera, whiteSphera } from 'src/utilities/UIStyles/variables/Colors';
import { spaceFlowContainer } from 'src/utilities/UIStyles/variables/spacing';

export const PersonalInformationContainer = styled.section`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  background-color: rgb(245, 245, 245);

  .card-container {
    ${spaceFlowContainer()}
    min-height: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    > h2 {
      color: ${graySphera};
      font-size: 1.5vw;
      margin-top: 5%;
    }

    > div {
      width: 80%;
    }
  }
`;

export const Banner = styled.div`
  ${spaceFlowContainer(true)}

  background-color: ${whiteSphera};
  padding: 0 0 2.5% 10%;
  > div {
    display: flex;
    justify-content: left;
    align-items: center;
    width: 100%;
    > figure {
      width: 8%;
      height: 8%;
      margin-right: 2.5%;

      > img {
        width: 100%;
        height: 100%;
      }
    }
    > h2 {
      color: ${graySphera};
      font-size: 2vw;
    }
  }

  @media (max-width: 600px) {
    > div {
      justify-content: center;
      > figure {
        width: 65px;
        height: 65px;
        > img {
        }
      }
      > h2 {
        font-size: 4vw;
        width: 70%;
      }
    }
  }
`;

export const Container = styled.div`
  ${spaceFlowContainer()}

  display: flex;
  justify-content: space-around;

  text-align: center;
`;
